export const Login_Route = '/login';
export const Reviews_Route = '/reviews'
export const Orders_Route = '/orders';
export const Register_Route = '/register';
export const Demo_Pay_Route = '/demoPay';